import {
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { fromStore } from 'angular/app/core/store';
import { Feature, FeatureStatus } from '../../core/models/entities/feature';
import { FeaturesService } from 'angular/app/core/services/features.service';

@Directive({
  selector: '[appFeature]',
  standalone: true,
})
export class FeatureDirective {
  appFeature = input<string>();
  hideWhenReleased = input<boolean>();
  store = inject(Store);
  authUser = this.store.selectSignal(fromStore.selectAuthUser);
  contextOnly = input<boolean>();
  featuresService = inject(FeaturesService);

  private isViewCreated = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
    effect(async () => {
      if (this.featuresService.features.length === 0) {
        await this.featuresService.findAndSet();
      }

      if (!this.authUser() || this.featuresService.features.length === 0) {
        return;
      }

      const feature = this.featuresService.features.find(
        (feature: Feature) => feature.name === this.appFeature(),
      );

      const featureIsReleased = feature?.status === FeatureStatus.Released;
      const isBeta = feature?.status !== FeatureStatus.Released;
      const vendorHasAccess = this.authUser().vendor.features.some(
        (f: Feature) => f.name === this.appFeature(),
      );
      const hasBetaAccess = isBeta && vendorHasAccess;
      const showFeature = featureIsReleased || vendorHasAccess;

      if (this.contextOnly()) {
        this.viewContainerRef.clear();
        this.viewContainerRef.createEmbeddedView(this.templateRef, {
          isBeta,
          showFeature,
          hasBetaAccess,
        });
        return;
      }

      if (!this.isViewCreated && showFeature) {
        this.viewContainerRef.createEmbeddedView(this.templateRef, { isBeta });
        this.isViewCreated = true;
      } else if (this.isViewCreated && !showFeature) {
        this.viewContainerRef.clear();
        this.isViewCreated = false;
      }
    });
  }
}
